import { useWSMutation } from "../../helpers";
import { QUERY_MONITOR_SETTINGS_ITEM } from "../keys";
import { createMonitorSettings } from "../../../services/api/insurance/monitorSettings/createMonitorSettings";

export const useMutationCreateMonitorSettings = () =>
  useWSMutation(createMonitorSettings, {
    dependencies(payload) {
      return [
        QUERY_MONITOR_SETTINGS_ITEM,
        payload.insuranceCoverageMonitorSettingsId
      ];
    }
  });
